var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.836,
    height: 22.455,
    id: "slots",
    viewBox: "0 0 35.836 22.455",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-slot-machine-2843263",
    transform: "translate(-73.965 -115.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_745",
    "data-name": "Trazado 745",
    d: "M88.737,219.376a1.987,1.987,0,0,0-1.985,1.985v11.383a1.987,1.987,0,0,0,1.985,1.985h7.331V219.376Zm5.427,9.879a1.8,1.8,0,0,1-1.02.3,2.3,2.3,0,0,1-.411-.04l.635,1.266a.4.4,0,0,1-.355.574H89.8a.4.4,0,0,1-.355-.574l.634-1.266a2.224,2.224,0,0,1-.408.04,1.8,1.8,0,0,1-1.022-.3,3.048,3.048,0,0,1-.982-2.8,4.293,4.293,0,0,1,2.355-3.106,13.48,13.48,0,0,1,1.22-.6l.014,0a.312.312,0,0,1,.083-.018.426.426,0,0,1,.068-.013.4.4,0,0,1,.068.013.484.484,0,0,1,.083.018l.013,0a13.509,13.509,0,0,1,1.219.6,4.29,4.29,0,0,1,2.356,3.106,3.056,3.056,0,0,1-.985,2.8Z",
    transform: "translate(-12.787 -97.228)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_746",
    "data-name": "Trazado 746",
    d: "M235.28,219.38v15.353H244.6V219.38Zm7.414,9.879a1.8,1.8,0,0,1-1.02.3,2.25,2.25,0,0,1-.408-.04l.634,1.266a.4.4,0,0,1-.017.386.4.4,0,0,1-.338.188h-3.211a.4.4,0,0,1-.338-.188.391.391,0,0,1-.017-.386l.634-1.266a2.242,2.242,0,0,1-.41.04,1.8,1.8,0,0,1-1.02-.3,3.045,3.045,0,0,1-.983-2.8,4.29,4.29,0,0,1,2.356-3.106c.412-.238.842-.432,1.219-.6.006,0,.013,0,.017,0a.338.338,0,0,1,.055-.013.4.4,0,0,1,.1-.017.356.356,0,0,1,.049.01.468.468,0,0,1,.1.021l.011,0c.4.182.811.368,1.219.6a4.29,4.29,0,0,1,2.356,3.106,3.049,3.049,0,0,1-.983,2.8Z",
    transform: "translate(-151.205 -97.232)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_747",
    "data-name": "Trazado 747",
    d: "M391.161,219.374H383.83v15.353h7.331a1.987,1.987,0,0,0,1.985-1.985V221.359a1.986,1.986,0,0,0-1.984-1.985Zm.083,9.879a1.8,1.8,0,0,1-1.022.3,2.248,2.248,0,0,1-.408-.04l.634,1.266a.4.4,0,0,1-.017.386.4.4,0,0,1-.338.188h-3.21a.4.4,0,0,1-.339-.188.391.391,0,0,1-.017-.386l.635-1.266a2.258,2.258,0,0,1-.41.04,1.8,1.8,0,0,1-1.02-.3,3.044,3.044,0,0,1-.982-2.8,4.29,4.29,0,0,1,2.356-3.106,13.586,13.586,0,0,1,1.219-.6s.01,0,.013,0a5.263,5.263,0,0,1,.152-.03.444.444,0,0,1,.067.013.46.46,0,0,1,.083.018l.014,0a13.435,13.435,0,0,1,1.22.6,4.3,4.3,0,0,1,2.357,3.106,3.052,3.052,0,0,1-.984,2.8Z",
    transform: "translate(-289.644 -97.226)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_748",
    "data-name": "Trazado 748",
    d: "M537.865,117.692a2.645,2.645,0,1,0-3.439,2.509v8.034a.8.8,0,0,1-.794.794h-1.273v1.588h1.273a2.386,2.386,0,0,0,2.382-2.382V120.2a2.641,2.641,0,0,0,1.85-2.51Z",
    transform: "translate(-428.064 0)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_913",
    "data-name": "Rect\\xE1ngulo 913",
    width: 8,
    height: 10,
    transform: "translate(94.91 124.618)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_914",
    "data-name": "Rect\\xE1ngulo 914",
    width: 8,
    height: 10,
    transform: "translate(84.91 124.618)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_915",
    "data-name": "Rect\\xE1ngulo 915",
    width: 8,
    height: 10,
    transform: "translate(74.623 124.618)",
    fill: "#ffce05"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BIBLIOTECA",
    transform: "translate(95.91 133.502)",
    fill: "#14172c",
    fontSize: 10,
    fontFamily: "Gotham-Black, Gotham",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    id: "BIBLIOTECA-2",
    "data-name": "BIBLIOTECA",
    transform: "translate(85.91 133.502)",
    fill: "#14172c",
    fontSize: 10,
    fontFamily: "Gotham-Black, Gotham",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    id: "BIBLIOTECA-3",
    "data-name": "BIBLIOTECA",
    transform: "translate(74.91 133.502)",
    fill: "#14172c",
    fontSize: 10,
    fontFamily: "Gotham-Black, Gotham",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slots.9a45af396e5f15ca76f26c0fdf28e220.svg";